import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[7.5rem_minmax(10rem,2fr)_8rem_10rem_minmax(8.5rem,1.5fr)_5rem_5.5rem_3.5rem_6.5rem_7.5rem_3.5rem]";
const gridGap = "md:gap-3";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, gridGap, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 11;

const ManagerListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 truncate";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, gridGap, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Status</span>
      <span className={headerStyle}>Nome</span>
      <span className={headerStyle}>Tipo</span>
      <span className={headerStyle}>Modelo de gestão</span>
      <span className={headerStyle}>Representante</span>
      <span className={headerStyle}>Clientes</span>
      <span className={headerStyle}>Usuários</span>
      <span className={headerStyle}>UCs</span>
      <span className={headerStyle}>Criado em</span>
      <span className={headerStyle}>Atualizado em</span>
      <span className={cn(headerStyle, "text-right")}>Ações</span>
    </div>
  );
};

export default ManagerListHeader;
